import Vue from 'vue';

function sLookup(url) {
  var l = (screen.availWidth - 560) / 2;
  var t = (screen.availHeight - 614) / 2;

  window.open(
    url,
    '_blank',
    'width=560,height=614,top=' +
      t +
      ',left=' +
      l +
      ',toolbar=no,menubar=no, scrollbars=no, resizable=no, location=no, status=no'
  );
}

function editWindow(url) {
  var l = (screen.availWidth - 1440) / 2;
  var t = (screen.availHeight - 900) / 2;

  window.open(
    url,
    '_blank',
    'width=1440,height=900,top=' +
      t +
      ',left=' +
      l +
      ',toolbar=no,menubar=no, scrollbars=no, resizable=no, location=no, status=no'
  );
}

function showAlertDialog(title, content, options) {
  return Vue.prototype.$alert(content, title, options);
}

function alert(content, callback) {
  showAlertDialog('提示', content, {
    callback: callback
  });
}

function confirm(content, options = {}) {
  return showConfirmDialog('', content, '确定', '取消', 'info');
}

function showConfirmDialog(
  title,
  content,
  confirmButtonContent,
  CancelButtonContent,
  confirmType
) {
  return Vue.prototype.$confirm(content, title, {
    confirmButtonText: confirmButtonContent,
    CancelButtonText: CancelButtonContent,
    type: confirmType
  });
}

let loadingInstance = null;

function showLoadingToast(content, dom) {
  if (!!loadingInstance) {
    return;
  }
  let options = {};
  if (!rt.isNull(content)) {
    options.text = content;
  }
  if (!rt.isNull(dom)) {
    options.target = dom;
  }
  loadingInstance = Vue.prototype.$loading(options);
}

function hideLoadingToast() {
  if (!loadingInstance) {
    return;
  }
  loadingInstance.close();
  loadingInstance = null;
}

function showErrorToast(error = '', isClose) {
  Vue.prototype.$message({
    showClose: isClose || true,
    message: error.message || error,
    type: 'error',
    wrapperClass: '.app-body'
  });
}

function showSuccessToast(content, isClose) {
  Vue.prototype.$message({
    showClose: isClose || true,
    message: content,
    type: 'success',
    wrapperClass: '.app-body'
  });
}

export {
  sLookup,
  editWindow,
  showAlertDialog,
  alert,
  confirm,
  showConfirmDialog,
  showSuccessToast,
  showErrorToast,
  showLoadingToast,
  hideLoadingToast
};



// WEBPACK FOOTER //
// ./~/vue-xpc/src/libs/ui.js